import { useFocusableDiv } from '../hooks';
import { Control, useController } from 'react-hook-form';

export interface FormFieldPropsServiceC2C {
  name: string;
  control: Control;
  services?: []
  setServices?: any;
  selected_services?: [];
}
/**
 * Create control field to use by the form.
 */
export const createControlFieldServicesc2c = (
  InnerComponent: React.ComponentType<{ value: any; onChange: any, services: any, setServices:any, selected_services:any}>,
  defaultValue = null
) => ({ name, control, services=null, setServices=null, selected_services=null}: FormFieldPropsServiceC2C) => {
  const { divRef, focus } = useFocusableDiv();
  const {
    field: { value, onChange },
  } = useController({ name, control, onFocus: focus, defaultValue });
  return (
    <div ref={divRef}>
      <InnerComponent value={value} onChange={onChange} services={services} selected_services={selected_services} setServices={setServices}/>
      {/* <InnerComponent value={(selected_services !=null && selected_services?.length > 0) ? selected_services : []} onChange={onChange} services={services} selected_services={selected_services} setServices={setServices}/> */}
    </div>
  );
};
